import {
  Box,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import * as constants from "../constants";

const sections = [
  {
    title: "Links",
    links: [
      {
        title: "Documentation",
        href: "/app/docs/welcome",
      },
      {
        title: "Technical Co-sponsorship",
        href: "/app/society/technical-co-sponsorship-applications/new",
      },
      {
        title: "Request for Submission System",
        href: "/app/society/system-activation-applications/new",
      },
      {
        title: "Sponsored Conferences",
        href: "/app/society/sponsored-conference-applications/new",
      },
    ],
  },
  {
    title: "Placeholders",
    links: [
      {
        title: "IEEE Sitemap",
        href: constants.IEEE_SITEMAP,
      },
      {
        title: "Contact Society",
        href: constants.IES_CONTACT,
      },
      {
        title: "Accessibility",
        href: constants.IES_ACCESSIBILITY,
      },
      {
        title: "Nondiscrimination Policy",
        href: constants.IES_NONDISCRIMINATION_POLICY,
      },
      {
        title: "IEEE Ethics Reporting",
        href: constants.IEEE_ETHICS_REPORTING,
      },
      {
        title: "IEEE Privacy Policy",
        href: constants.IEEE_PRIVACY_POLICY,
      },
      {
        title: "Terms",
        href: constants.IEEE_TERMS,
      },
      {
        title: "Support (conferences@ieee-ies.org)",
        href: `mailto:conferences@ieee-ies.org?Subject=IES Conference Community support`,
      },
    ],
  },
  {
    title: "Social",
    links: [
      {
        title: "Facebook",
        href: constants.IES_FACEBOOK,
      },
      {
        title: "Twitter",
        href: constants.IES_TWITTER,
      },
      {
        title: "LinkedIn",
        href: constants.IES_LINKEDIN,
      },
      {
        title: "Youtube",
        href: constants.IES_YOUTUBE,
      },
    ],
  },
];

const PublicFooter = (props) => (
  <Box
    sx={{
      backgroundColor: "background.default",
      borderTopColor: "divider",
      borderTopStyle: "solid",
      borderTopWidth: 1,
      pb: 6,
      pt: {
        md: 15,
        xs: 6,
      },
    }}
    {...props}
  >
    <Container maxWidth="lg">
      <Grid container spacing={3}>
        <Grid
          item
          md={3}
          sm={4}
          sx={{
            display: "flex",
            flexDirection: "column",
            order: {
              md: 1,
              xs: 4,
            },
          }}
          xs={12}
        >
          <img width="60%" alt="IES Logo" src={`/static/home/logo.png`} />
          <Typography color="textSecondary" sx={{ mt: 1 }} variant="caption">
            © 2022 IES Conferences Community
          </Typography>
        </Grid>
        {sections.map((section, index) => (
          <Grid
            item
            key={section.title}
            md={3}
            sm={4}
            sx={{
              order: {
                md: index + 2,
                xs: index + 1,
              },
            }}
            xs={12}
          >
            <Typography color="textSecondary" variant="overline">
              {section.title}
            </Typography>
            <List disablePadding>
              {section.links.map((link) => (
                <ListItem
                  disableGutters
                  key={link.title}
                  sx={{
                    pb: 0,
                    pt: 1,
                  }}
                >
                  <ListItemAvatar
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      minWidth: 0,
                      mr: 0.5,
                    }}
                  >
                    <RemoveOutlinedIcon color="primary" />
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Link
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        color="textPrimary"
                        variant="subtitle2"
                      >
                        {link.title}
                      </Link>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
        ))}
      </Grid>
      <Divider
        sx={{
          borderColor: (theme) =>
            alpha(theme.palette.primary.contrastText, 0.12),
          my: 5,
        }}
      />
      <Typography color="textSecondary" variant="caption">
        © Copyright 2023 IEEE - All rights reserved. A not-for-profit
        organization, IEEE is the world's largest technical professional
        organization dedicated to advancing technology for the benefit of
        humanity.
      </Typography>
    </Container>
  </Box>
);

export default PublicFooter;
